import React from 'react';
import ReactDOM from 'react-dom/client';
// Il foglio di stile di react-toastify: senza, il contenitore degli avvisi non e' ne'
// posizionato ne' visibile (finisce in coda al body, fuori schermo) e l'animazione di uscita
// non parte mai, quindi nessun avviso sparisce piu'. Sta qui e una volta sola perche' i
// ToastContainer sono sparsi per le pagine. `index.css` viene dopo: le sue custom properties
// (la palette dei toast) sovrascrivono quelle di default.
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {persistor, store} from './app/store'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
